function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.6912 0.308584C15.8231 0.440405 15.9149 0.698662 15.9153 0.868049L16 10.4679C15.9979 10.91 15.6635 11.2954 15.1813 11.3311C14.7502 11.363 14.3551 10.9796 14.3525 10.5487L14.2907 2.8487L1.39322 15.7461C1.06476 16.0746 0.543465 16.0858 0.228836 15.7712C-0.0857923 15.4565 -0.0745975 14.9352 0.253863 14.6068L13.1513 1.70934L5.45126 1.6475C5.02049 1.64487 4.65601 1.25 4.66892 0.818778C4.68258 0.363508 5.08999 -0.00458857 5.53209 4.32374e-05L15.132 0.0846669C15.4031 0.0762168 15.5551 0.177175 15.6912 0.308584Z",
  fill: "#D18F1F"
});
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.4dbfa0f9896d9e4bdb65639a6b61a5bc.svg";
export { ForwardRef as ReactComponent };